import React from "react";
import { NavLink } from "react-router-dom";
import ApiTable from "./components/ApiTable";

const index = () => {
  return (
    <>
      <ApiTable />
    </>
  );
};

export default index;
